<template>
  <bsp-dialog :title="title" :dialogVisible.sync="visible" top="15vh" @closeButton="close" width="500px" :needMinHeight="false">
    <template #body v-loading="loading">
      <el-form ref="mainForm" :model="mainForm" label-width="80px" :rules="rules">
        <el-form-item :label="labelName" prop="optNote" class="form-item-content-auto">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5}"
            maxlength="500"
            v-model="mainForm.optNote"
            clearable
          />
        </el-form-item>
      </el-form>
    </template>
    <div class="dialog-footer" slot="footer">
      <el-button type="default" @click="close">{{$t('cost.cost079')}}</el-button><!-- 取 消 -->
      <el-button type="primary" @click="submitForm('mainForm')" :loading="loading">{{$t('cost.cost078')}}</el-button><!-- 确 定 -->
    </div>
  </bsp-dialog>
</template>
<script>
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import { approveWithdrawCloud, manageApproveCloud } from "@/api/cost/cost";
import { mapGetters } from 'vuex';
export default {
  name: "optDialog",
  components: {
    BspDialog
  },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
          tdId:"",
          btnType:"",
        };
      },
    },
  },
  computed: {
    ...mapGetters([
      'accessToken',
      'dicts'
    ]),
    codeMap() {
      return this.dicts.codeMap;
    }
  },
  watch: {
  },
  created() {
  },
  data () {
    return {
      labelName : "",
      loading: false,
      visible: false,
      searchParams: {},
      pageTitle: "",
      mainForm: {
      },
      title: "",
      rules: {
        optNote: [
          { required: true, message: this.$t('cost.cost106'), trigger: 'change' } //请填写原因说明
        ]
      }
    }
  },
  methods: {
    init() {
      this.demoLoading = true;

      if(this.optParams.flag == "BXDCH"){
        //后道退回
        this.title = this.$t('cost.cost017'); //报销单撤回
        this.labelName = this.$t('cost.cost108');//撤回原因
      }else if(this.optParams.flag == "BXDBH"){
        this.title = this.$t('cost.cost109');//报销单驳回
        this.labelName = this.$t('cost.cost010');//驳回原因
      }
      //this.mainForm = this.optParam;
    },
    // 清空表单
    resetForm (formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },

    close (){
      this.clearForm();
      this.resetForm("mainForm");
      this.visible = false;
    },

    // 级联change事件，清空子项下拉选项和选中值
    clearForm(type) {
      // 获取语言
      this.mainForm = {
        optNote:''
      };
      this.resetForm('mainForm');
    },
    // 确认
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.demoLoading = true;

          if(this.optParams.flag == "BXDCH"){
            //报销单撤回
            this.approveWithdrawCloud();
          }else if(this.optParams.flag == "BXDBH"){
            //报销单驳回
            this.manageApproveBackCloud();
          }
        }
      });
    },
    approveWithdrawCloud(){
      let params = {
        costId: this.optParams.costId,
        option: this.mainForm.optNote,
      }

      approveWithdrawCloud({mainForm : params})
        .then(res => {
          this.demoLoading = false;
          let result = res.data;
          if (result.code == 0) {
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            this.$emit('reload');
            this.resetForm("mainForm");
            this.visible = false;
          } else {
            this.$message.error(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        })
    },
    manageApproveBackCloud(){
      let params = {
        costId: this.optParams.costId,
        option: this.mainForm.optNote,
        flag: "notok"
      }

      manageApproveCloud({mainForm : params})
        .then(res => {
          this.demoLoading = false;
          let result = res.data;
          if (result.code == 0) {
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            this.$emit('reload');
            this.resetForm("mainForm");
            this.visible = false;
          } else {
            this.$message.error(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        })
    },
  }
}
</script>
